var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconClose02(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.65608 20.6473L4.83286 20.824L5.00964 20.6473L12.0003 13.6566L18.9909 20.6473L19.1677 20.824L19.3445 20.6473L20.6476 19.3441L20.8244 19.1673L20.6476 18.9905L13.657 11.9999L20.6476 5.00924L20.8244 4.83246L20.6476 4.65569L19.3445 3.35252L19.1677 3.17574L18.9909 3.35252L12.0003 10.3432L5.00964 3.35252L4.83286 3.17574L4.65608 3.35252L3.35292 4.65569L3.17614 4.83246L3.35292 5.00924L10.3436 11.9999L3.35292 18.9905L3.17614 19.1673L3.35292 19.3441L4.65608 20.6473Z",
    fill: "#222222",
    stroke: "#222222",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose02);
export default __webpack_public_path__ + "static/media/icon_close02.2a1a0150f64635105bbd59586d2fd8b3.svg";
export { ForwardRef as ReactComponent };